function removeAddToCartQueryParam(): void {
  const url = new URL(window.location.href);
  if (
    !url.searchParams.has('addToCart') ||
    url.searchParams.get('addToCart') !== 'true'
  ) {
    return;
  }
  url.searchParams.delete('addToCart');
  window.history.replaceState('', '', url.href);
}

// click the add to cart button if the url has ?addToCart=true
export function maybeClickAddToCartButton(): void {
  const searchParams = new URLSearchParams(window.location.search);
  const addToCart = searchParams.get('addToCart');
  if (addToCart === 'true') {
    const addToCartButton = document.querySelector(
      '.product-form__item--submit button[name="add"]'
    );
    if (addToCartButton && addToCartButton instanceof HTMLButtonElement) {
      // small delay to allow the cart to finish loading before clicking the button
      setTimeout(() => {
        addToCartButton.click();
        removeAddToCartQueryParam();
      }, 200);
    }
  }
}
